import React, { useContext } from "react";
import PropTypes from "prop-types";
import POSContext from "./POSContext";
import paymentMethods from "utils/static/paymentMethods";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";

function DetailTable({ data, resources, onRowClick, onRowsDeleted, isUserCreating }) {
    const { categories } = resources;
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();
    const { Detail } = useContext(POSContext);
    const getCategory = (id) => categories.find((x) => x.id === id);
    const getPaymentMethod = (value) => paymentMethods.find((x) => x.value === value);

    const headCells = [
        {
            index: 1,
            id: "categoryId",
            disablePadding: false,
            label: "Category",
            render: (_, { value }) => getCategory(value)?.name,
        },
        { index: 2, id: "amount", disablePadding: false, label: "Amount", type: "currency" },
        {
            index: 3,
            id: "paymentMethod",
            disablePadding: false,
            label: "Payment Method",
            render: (_, { value }) => getPaymentMethod(value)?.label,
        },
    ];

    function onDeleteSuccess(deletedItems) {
        dispatch(notifyInfo("Removed successfully!"));
        onRowsDeleted(deletedItems);
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Detail.deleteAll({
            ids: selectedItems,
            onSuccess: () => onDeleteSuccess(selectedItems),
            onError: onDeleteError,
        });
    }

    return (
        <div className="layout">
            <EnhancedTable
                headCells={headCells}
                data={data}
                onRowClick={onRowClick}
                keyColumnName="id"
                selectable={user.isAdmin || isUserCreating}
                deletable={user.isAdmin || isUserCreating}
                onDelete={(user.isAdmin || isUserCreating) && onDeleteHandler}
                filterable={false}
                pageable={false}
                orderable={false}
                dense
            />
        </div>
    );
}

DetailTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            amount: PropTypes.number,
            categoryId: PropTypes.number,
            paymentMethod: PropTypes.string,
        })
    ),
    resources: PropTypes.shape({
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                code: PropTypes.string,
                name: PropTypes.string,
            })
        ),
    }),
    onRowClick: PropTypes.func,
    isUserCreating: PropTypes.bool,
};

DetailTable.defaultProps = {
    data: [],
    resources: {
        categories: [],
    },
    onRowClick: (item) => true,
    isUserCreating: false,
};

export default DetailTable;
